import { combine, createEffect, createStore } from "effector"

import UserService from "services/UserService"
import GlobalAssetOverviewTenant from "models/GlobalAssetOverviewTenant"
import { Guid } from "@/types"


export const $globalAssetOverviewTenants = createStore<GlobalAssetOverviewTenant[] | null>(null)
export const $globalAssetOverviewTenantsWithoutCurrentTenant = createStore<GlobalAssetOverviewTenant[] | null>(null)

export const $tenantsMap = combine([
    $globalAssetOverviewTenants,
], ([tenants]) => {
    const map = new Map<Guid, GlobalAssetOverviewTenant>()
    tenants?.forEach(tenant => {
        map.set(tenant.id, tenant)
    })
    return map
})

export const fetchGlobalAssetOverviewTenants = createEffect(async () => {
    const cache = $globalAssetOverviewTenants.getState()
    if (cache) return cache
    return UserService.getGlobalAssetOverviewTenants({
        includeCurrentTenant: true,
    })
})

export const fetchGlobalAssetOverviewTenantsWithoutCurrentTenant = createEffect(async () => {
    const cache = $globalAssetOverviewTenantsWithoutCurrentTenant.getState()
    if (cache) return cache
    return UserService.getGlobalAssetOverviewTenants({
        includeCurrentTenant: false,
    })
})

export const $isFetchingGlobalAssetOverviewTenants = combine([
    fetchGlobalAssetOverviewTenants.inFlight,
], ([count]) => count > 0)

export const $isFetchingGlobalAssetOverviewTenantsWithoutCurrentTenant = combine([
    fetchGlobalAssetOverviewTenantsWithoutCurrentTenant.inFlight,
], ([count]) => count > 0)

$globalAssetOverviewTenants.on(fetchGlobalAssetOverviewTenants.doneData, (_, tenants) => tenants)
$globalAssetOverviewTenantsWithoutCurrentTenant.on(fetchGlobalAssetOverviewTenantsWithoutCurrentTenant.doneData, (_, tenants) => tenants)
